<template>
  <div>
    <!-- Layout compatto (per desktop 4 o 6) -->
    <div v-if="layoutType === 'compact'">
      <a
        :href="ctaLink"
        :title="ctaTitle"
        :data-type="productType"
        class="text-decoration-none card-width"
      >
        <div :class="['quotation-card', borderType]" :style="[borderCardColor, bgCardColor]">
          <div class="quotation-card-header">
            <div class="logo-quotazioni">
              <img :src="logoUrl ? logoUrl : logoImage" :alt="logoAlt" />
            </div>
            <div class="corner" v-if="promo" :style="promoBgColor">
              <span v-if="labelPromo" :style="promoTextColor">{{ labelPromo }}</span>
              <span v-else>Promo</span>
            </div>
          </div>
          <div class="quotation-card-title">
            <h5 :style="textCardColor">{{ title }}</h5>
          </div>
          <div class="quotation-card-description">
            <p v-html="description" :style="textCardColor"></p>
          </div>
          <div class="quotation-btn">
            <button
              :title="ctaTitle"
              :class="['quotation-card-btn', colorType]"
              :data-type="productType"
              :style="ctaCardColor"
            >
              <span :class="[promo ? 'line-through' : '']">{{ labelCta }}</span>
              <span v-if="price" class="text-decoration-none">{{ price }}</span>
              <span>
                <svg
                  class="slide-right"
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="10.2"
                  viewBox="0 0 6 10.2"
                >
                  <g
                    id="Arrow-Small_down"
                    data-name="Arrow-Small down"
                    transform="translate(0 10.2) rotate(-90)"
                  >
                    <path
                      id="Arrow-Small_down-2"
                      data-name="Arrow-Small down"
                      d="M4.338.9A1,1,0,0,1,5.862.9L8.8,4.352A1,1,0,0,1,8.038,6H2.162A1,1,0,0,1,1.4,4.352Z"
                      transform="translate(10.2 6) rotate(180)"
                      :fill="cardBorderColor ? cardBorderColor : fillType"
                    />
                  </g>
                </svg>
              </span>
            </button>
          </div>
        </div>
      </a>
      <div></div>
    </div>

    <!-- Layout "middle" (per desktop = 8) -->
    <div v-else-if="layoutType === 'middle'">
      <a
        :href="ctaLink"
        :title="ctaTitle"
        :data-type="productType"
        class="text-decoration-none"
      >
        <div
          :class="['quotation-card-middle', borderType, bgColor]"
          :style="[borderCardColor, bgCardColor]"
        >
          <div class="quotation-card-middle-header">
            <div class="logo-quotazioni-middle">
              <img img :src="logoUrl ? logoUrl : logoImage" :alt="logoAlt" />
            </div>
            <div class="corner" v-if="promo" :style="promoBgColor">
              <span v-if="labelPromo" :style="promoTextColor">{{ labelPromo }}</span>
              <span v-else>Promo</span>
            </div>
          </div>
          <div class="quotation-card-middle-title">
            <h5 :style="textCardColor">{{ title }}</h5>
          </div>
          <div class="quotation-card-middle-description">
            <p v-html="description" :style="textCardColor"></p>
          </div>
          <div
            :class="['quotation-btn-middle', borderType]"
            :style="cardBorderColor ? { border: `2px solid ${cardBorderColor}` } : {}"
          >
            <button
              :title="ctaTitle"
              :class="['quotation-card-middle-btn', colorType]"
              :data-type="productType"
              :style="ctaCardColor"
            >
              {{ labelCta }}
            </button>
          </div>
        </div>
      </a>
    </div>

    <!-- Layout full (per desktop = 12) -->
    <div v-else-if="layoutType === 'full'">
      <a :href="ctaLink" :title="ctaTitle" :data-type="productType" class="text-decoration-none">
        <div :class="['quotation-card-full', borderType]" :style="[borderCardColor, bgCardColor]">
          <div class="quotation-card-full-header">
            <div class="logo-quotazioni-full">
              <img img :src="logoUrl ? logoUrl : logoImage" :alt="logoAlt" />
            </div>
            <div class="corner" v-if="promo" :style="promoBgColor">
              <span v-if="labelPromo" :style="promoTextColor">{{ labelPromo }}</span>
              <span v-else>Promo</span>
            </div>
          </div>
          <div class="quotation-card-full-body">
            <div class="quotation-card-full-title">
              <h5 :style="textCardColor">{{ title }}</h5>
            </div>
            <div class="quotation-card-full-description">
              <p v-html="description" :style="textCardColor"></p>
            </div>
            <div class="card-full-quotation-btn">
              <button
                :title="ctaTitle"
                :class="['quotation-card-full-btn', colorType]"
                :data-type="productType"
                :style="ctaCardColor"
              >
                <span :class="[promo ? 'line-through' : '']">{{ labelCta }}</span>
                <span v-if="price" class="text-decoration-none">{{ price }}</span>
                <span>
                  <svg
                    class="slide-right"
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="10.2"
                    viewBox="0 0 6 10.2"
                  >
                    <g
                      id="Arrow-Small_down"
                      data-name="Arrow-Small down"
                      transform="translate(0 10.2) rotate(-90)"
                    >
                      <path
                        id="Arrow-Small_down-2"
                        data-name="Arrow-Small down"
                        d="M4.338.9A1,1,0,0,1,5.862.9L8.8,4.352A1,1,0,0,1,8.038,6H2.162A1,1,0,0,1,1.4,4.352Z"
                        transform="translate(10.2 6) rotate(180)"
                        :fill="cardBorderColor ? cardBorderColor : fillType"
                      />
                    </g>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardProduct',
  props: {
    sizes: {
      type: Object,
      default: () => ({ mobile: 12, tablet: 12, desktop: 12 }),
    },
    productType: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    labelCta: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: '',
    },
    cardBgColor: {
      type: String,
      default: '',
    },
    cardTextColor: {
      type: String,
      default: '',
    },
    cardBorderColor: {
      type: String,
      default: '',
    },
    promo: {
      type: Boolean,
      default: false,
    },
    bgColorPromo: {
      type: String,
      default: '',
    },
    textColorPromo: {
      type: String,
      default: '',
    },
    labelPromo: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
  },
  computed: {
    layoutType() {
      const desktopVal = parseInt(this.sizes.desktop);
      if (desktopVal === 4 || desktopVal === 6) {
        return 'compact';
      } else if (desktopVal === 8) {
        return 'middle';
      } else if (desktopVal === 12) {
        return 'full';
      }
      return 'compact';
    },
    borderType() {
      return {
        '1': 'rounded-blue',
        '2': 'rounded-red',
        '5': 'rounded-green',
        '3': 'rounded-black',
      }[this.productType];
    },
    colorType() {
      return {
        '1': 'nominal-color',
        '2': 'live-market-color',
        '5': 'historic-color',
        '3': 'classic-color',
      }[this.productType];
    },
    fillType() {
      return {
        '1': '#006cd7',
        '2': '#d20a11',
        '5': '#218c74',
        '3': '#111e41',
      }[this.productType];
    },
    bgColor() {
      return {
        '1': 'nominal-bg',
        '2': 'live-market-bg',
        '5': 'historic-bg',
        '3': 'classic-bg',
      }[this.productType];
    },
    logoImage() {
      return {
        '1': '../../../images/project-img/Logo_quotazioni.png',
        '2': '../../../images/project-img/quotazioni-livemarket-logo.png',
        '5': '../../../images/project-img/quotazioni-storica-logo.png',
        '3': '../../../images/project-img/quotazioni-ruoteclassiche-logo.png',
      }[this.productType];
    },
    logoAlt() {
      return {
        '1': 'Logo Quotazioni Nominale Quattroruote',
        '2': 'Logo Quotazioni Live Market Quattroruote',
        '5': 'Logo Quotazioni Storica Quattroruote',
        '3': 'Logo Quotazioni Ruote Classiche Quattroruote',
      }[this.productType];
    },
    ctaLink() {
      if (this.productType === '1' || this.productType === 'sponsor') {
        return '/nominale';
      } else if (this.productType === '3') {
        return '/autoepoca';
      } else if (this.productType === '2') {
        return '/livemarket';
      } else if (this.productType === '5') {
        return '/storica';
      }
      return '#';
    },
    ctaTitle() {
      if (this.productType === '1' || this.productType === 'sponsor') {
        return 'Scopri la Quotazione Nominale Quattroruote';
      } else if (this.productType === '3') {
        return 'Scopri la Quotazione Ruote Classiche Quattroruote';
      } else if (this.productType === '2') {
        return 'Scopri il Report Live Market';
      } else if (this.productType === '5') {
        return 'Scopri la Quotazione Storica Quattroruote';
      }
      return '';
    },
    borderCardColor() {
      return this.cardBorderColor ? { border: `2px solid ${this.cardBorderColor}` } : {};
    },
    bgCardColor() {
      return this.cardBgColor ? { backgroundColor: `${this.cardBgColor}` } : {};
    },
    textCardColor() {
      return this.cardTextColor ? { color: `${this.cardTextColor}` } : {};
    },
    ctaCardColor() {
      return this.cardBorderColor ? { color: `${this.cardBorderColor}` } : {};
    },
    promoBgColor() {
      return this.bgColorPromo ? { borderTop: `80px solid ${this.bgColorPromo}` } : {};
    },
    promoTextColor() {
      return this.textColorPromo ? { color: `white` } : {};
    },
  },
};
</script>

<style scoped>
.quotation-card {
  margin: 30px auto 0;
  /* width: calc(100% - 20px); */
  border-radius: 6px;
  background-color: #efefef;
  color: white;
  box-shadow: 0px 10px 30px #0000001a;
}
@media screen and (max-width: 768px) {
  .quotation-card {
    /* width: calc(100% - 20px); */
    margin: 20px auto;
  }
}

.quotation-card-header {
  background-color: white;
  height: 135px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 6px 6px 0 0;
}
.logo-quotazioni {
  padding: 40px 0;
  img {
    width: 200px;
    margin: 0 auto;
  }
}

.corner {
  width: 0;
  height: 0;
  border-top: 80px solid #ffcc00;
  border-bottom: 80px solid transparent;
  border-left: 80px solid transparent;
  border-top-right-radius: 4px;
  position: absolute;
  right: 0;
  top: 0;
}

.corner span {
  color: #606060;
  font-weight: 700;
  position: absolute;
  top: -57px;
  width: 100px;
  left: -77px;
  text-align: center;
  font-size: 14px;
  transform: rotate(45deg);
  display: block;
}

.quotation-card-title {
  color: #606060;
  text-align: center;
  font-weight: 600;
  font-size: 1.2rem;
  margin: 30px;
}

.quotation-card-description {
  color: #606060;
  margin: 30px 15px;
  line-height: 24px;
  text-align: center;
  p {
    font-size: 14px;
  }
}

.quotation-btn {
  text-align: center;
  margin-bottom: 20px;
}

.quotation-card-btn {
  background-color: transparent;
  color: #006cd7;
  border: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
}

.quotation-card-btn:hover .slide-right {
  -webkit-animation: slide-right 0.3s ease-out both;
  animation: slide-right 0.3s ease-out both;
}

@-webkit-keyframes slide-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
}
@keyframes slide-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
}

.quotation-card-middle {
  margin: 30px auto 0;
  /* width: calc(100% - 20px); */
  border-radius: 6px;
  background-color: #efefef;
  color: white;
  box-shadow: 0px 10px 30px #0000001a;
}
@media screen and (max-width: 768px) {
  .quotation-card-middle {
    /* width: calc(100% - 20px); */
    margin: 20px auto;
  }
}

.quotation-card-middle-header {
  background-color: white;
  height: 135px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 6px 6px 0 0;
}
.logo-quotazioni-middle {
  padding: 40px 0;
  img {
    width: 200px;
    margin: 0 auto;
  }
}

.corner {
  width: 0;
  height: 0;
  border-top: 80px solid #ffcc00;
  border-bottom: 80px solid transparent;
  border-left: 80px solid transparent;
  border-top-right-radius: 4px;
  position: absolute;
  right: 0;
  top: 0;
}

.corner span {
  color: #606060;
  font-weight: 700;
  position: absolute;
  top: -57px;
  width: 100px;
  left: -77px;
  text-align: center;
  font-size: 14px;
  transform: rotate(45deg);
  display: block;
}

.quotation-card-middle-title {
  color: white;
  text-align: left;
  font-weight: 600;
  font-size: 1.5rem;
  margin: 30px;
}

.quotation-card-middle-description {
  color: white;
  margin: 30px;
  line-height: 24px;
  text-align: left;
  p {
    font-size: 1rem;
  }
}

.quotation-btn-middle {
  text-align: right;
  margin: 0 30px 15px auto;
  padding: 10px 30px;
  background-color: white;
  width: max-content;
  border-radius: 4px;
  box-shadow: 0px 10px 30px #00000024;
}

.quotation-card-middle-btn {
  background-color: transparent;
  border: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  text-decoration: none;
}

.quotation-card-full {
  /* width: calc(100% - 20px); */
  margin: 30px 0 0;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background-color: #efefef;
  color: white;
  box-shadow: 0px 10px 30px #0000001a;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    /* width: calc(100% - 20px); */
    margin: 20px auto;
  }
}

.quotation-card-full-header {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  @media screen and (max-width: 768px) {
    border-radius: 6px 6px 0 0;
    height: 135px;
  }
}
.logo-quotazioni-full {
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 200px;
    @media screen and (max-width: 768px) {
      border-radius: 6px 6px 0 0;
      padding: 30px 0;
    }
  }
  p {
    color: #111e41;
    font-weight: 400;
    font-size: 20px;
    margin: 20px 0;
  }
}

.quotation-card-full-body {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.quotation-card-full-title {
  color: #606060;
  font-weight: 600;
  font-size: 1.2rem;
  margin: 30px 0 0;
  text-align: center;
}

.quotation-card-full-description {
  color: #111e41;
  margin: 10px 30px 0;
  line-height: 24px;
  @media screen and (max-width: 768px) {
    margin: 10px 30px 30px;
  }
  p {
    font-size: 14px;
    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }
}

.card-full-quotation-btn {
  text-align: end;
  margin: 30px;
  @media screen and (max-width: 768px) {
    text-align: center;
  }
}

.quotation-card-full-btn {
  background-color: transparent;
  color: #111e41;
  border: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  text-decoration: none;
}

.quotation-card-full-btn:hover .slide-right {
  -webkit-animation: slide-right 0.3s ease-out both;
  animation: slide-right 0.3s ease-out both;
}

.rounded-blue {
  border-radius: 6px;
  border: 2px solid #006cd7;
}
.rounded-red {
  border-radius: 6px;
  border: 2px solid #d20a11;
}
.rounded-green {
  border-radius: 6px;
  border: 2px solid #218c74;
}
.rounded-black {
  border-radius: 6px;
  border: 2px solid #404041;
}

.nominal-color {
  color: #006cd7;
}
.live-market-color {
  color: #d20a11;
}
.historic-color {
  color: #218c74;
}
.classic-color {
  color: #111e41;
}
.nominal-bg {
  background-color: #006cd7;
}
.live-market-bg {
  background-color: #d20a11;
}
.historic-bg {
  background-color: #218c74;
}
.classic-bg {
  background-color: #111e41;
}
.line-through {
  text-decoration: line-through;
  text-decoration-thickness: 2px;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/CardProduct.vue